module.exports = __webpack_public_path__ + "static/media/GamePreloadPlaceholder.97619d48.png";